/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Cache from 'fierry/flux/cache';
import Client from 'fierry/flux/entity/client';

import Rpc from 'astro/rpc';
import Model from 'fierry/rpc.old/model';

import Time from 'astro/server/time';
import Queries from 'astro/rpc/queries';

import { isOffline } from 'shared/util/url';


export default class extends Model
{
  constructor (state, hierarchy)
  {
    super(state, hierarchy);

    this.currentTime = new Time(state);
  }


  log (location)
  {
    this.hierarchy.execute('user/log', { galaxy: '1f98bde1-8f99-4731-be8c-2bfa11abe829', location });
  }


  loginUser (token)
  {
    console.log('Login User', token != null);

    if (isOffline())
    {
      this.hierarchy.execute('user/login', { offline_token: token });
    }
    else
    {
      this.hierarchy.execute('user/login', { firebase_token: token });
    }
  }


  logoutUser ()
  {
    console.log('Logout User');

    this.hierarchy.execute('user/logout', { });
  }


  deleteUser (token)
  {
    this.hierarchy.execute('user/delete', { token });
  }


  getGalaxy()
  {
    return this.state.get('galaxy');
  }


  getCurrentTime()
  {
    return this.currentTime;
  }


};
